"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoTranslatePluralize;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inflector = _interopRequireDefault(require("../utils/inflector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inflector = new _inflector.default();

function NoTranslatePluralize(props) {
  var text = props.text,
      length = props.length;
  return (
    /*#__PURE__*/

    /* eslint-disable-next-line */
    _react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: inflector.notranslate_pluralize(text, length)
      }
    })
  );
}

NoTranslatePluralize.propTypes = {
  text: _propTypes.default.string.isRequired,
  length: _propTypes.default.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/base/NoTranslatePluralize.js
// module id = 539
// module chunks = 0 15 16 17 18